var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSocialsms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 23.5C18.0751 23.5 23 18.5751 23 12.5C23 6.42487 18.0751 1.5 12 1.5C5.92487 1.5 1 6.42487 1 12.5C1 18.5751 5.92487 23.5 12 23.5ZM8 9.89432C8 9.40484 8.4019 9 8.90741 9H15.5926C16.0981 9 16.5 9.40484 16.5 9.89432V13.6057C16.5 14.0952 16.0981 14.5 15.5926 14.5H10.1312C9.65416 14.5 9.20132 14.7103 8.89352 15.0748L8 16.1329V9.89432ZM8.90741 8C7.85844 8 7 8.84377 7 9.89432V17.5C7 17.7099 7.13111 17.8975 7.32826 17.9696C7.5254 18.0417 7.74658 17.983 7.88202 17.8226L9.65755 15.72C9.77535 15.5805 9.94866 15.5 10.1312 15.5H15.5926C16.6416 15.5 17.5 14.6562 17.5 13.6057V9.89432C17.5 8.84377 16.6416 8 15.5926 8H8.90741Z",
    fill: "currentcolor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialsms);
export default __webpack_public_path__ + "static/media/Social sms.120662c2966faa22c13a4dcc04963b74.svg";
export { ForwardRef as ReactComponent };